module.exports = __webpack_public_path__ + "img/大数据 拷贝.5069ce29.png";